import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Cascader, message, Select, Upload } from 'antd';
import { SDrawer, SGeneralForms, SLocalTreeSelected } from 'shj-components';
import ImageUpload from '@/components/Upload/ImageUpload'
import {
    findOrgTree,
    getEmployee,
    getRegionList,
    insertOrUpdateProjectExternalEmployee,
} from '@/services/externalPerson'
import {
    getBanksAreasList,
    getBanksList,
    getBanksLocationsList,
} from '@/services'
import { getEnums } from '@/services/homeService'
import { getWorkTypeList } from '@/services'
import backBankCard from '@/assets/backBankCard.png';
import bankCardFront from '@/assets/bankCardFront.png';
import cardFront from '@/assets/cardFront.png';
import nationalEmblem from '@/assets/nationalEmblem.png';
import selfPositive from '@/assets/selfPositive.png';
import { treeFormat, trimObj } from "@/utils/data.ts";
import { IConfig } from 'shj-components/dist/es/SGeneralForms/type';
import { getImgRelativePath } from '@/utils';
import { getVendorInfoList } from '@/services/workerManagement';
import { idRegExp, phoneRegExp } from '@/utils/regular';
import { map, cloneDeep } from 'lodash-es';
const Add = (props: any) => {
    const { Option } = Select;
    const formRef = useRef<any>()
    const { visibleDrawer = false, title = '新增', closeDetails, reloadList } = props
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [bankNameList, setBankNameList] = useState<any>([])
    const [banksLocationsList, setBanksLocationsList] = useState<any>([])
    const [banksAreasList, setBanksAreasList] = useState<any>([])
    const [bankCode, setBankCode] = useState<any>('')
    const [areaCode, setAreaCode] = useState<any>('')
    const [orgList, setOrgList] = useState<any>([])
    const [vendorInfoList, setVendorInfoList] = useState<any>([])
    const [ownerUserList, setOwnerUserList] = useState<any>([])
    const [provinceList, setProvinceList] = useState<any>([])
    // 控制整个身份证信息
    const [empFilePaths, setEmpFilePaths] = useState<any>(false)
    useEffect(() => {
        if (visibleDrawer) {
            formRef.current?.onFormRef()?.resetFields();
            formRef?.current?.updateOptions();
            setEmpFilePaths(false);
        }
    }, [visibleDrawer])
    const onSubmit = (values) => {
        // if (upDataIdCardInfo) {
        //     if (trimStr(upDataIdCardInfo.name) !== trimStr(values.userName)) {
        //         return message.error('姓名与身份证上姓名不一致，请检查')
        //     }
        //     if (trimStr(upDataIdCardInfo.num) !== trimStr(values.idCard)) {
        //         return message.error('身份证号码与身份证上号码不一致，请检查')
        //     }
        //     if (upDataIdCardInfo.sex !== (values.sex ? '男' : '女')) {
        //         return message.error('性别与身份证上性别不一致，请检查')
        //     }
        // }
        // 银行信息处理
        values.extAccountInfoRequest = {
            "bankName": values.bankName,
            "bankCode": bankCode,
            "openAccountName": values.name,
            "accountCode": values.accountCode,
            "cityCode": areaCode,
            "cityName": values.cityName,
            "bankBranchCode": values.bankBranchCode,
            "bankBranchName": values.bankBranchName,
            "bankBranchNumber": values.bankBranchNumber,
            "imgFrontUrl": getImgRelativePath(values.imgFrontUrl[0]),
            "imgBackUrl": getImgRelativePath(values.imgBackUrl[0]),
            "mainFlag": true,
            "idCard": values.idCard
        }
        let workTypeIds = [];
        workTypeIds = values.workTypeIds.map(item =>item.value)
        let formObj = {
            ...values,
            workTypeIds,
            censusRegisterAreaCode: values.censusRegisterAreaCode ? values.censusRegisterAreaCode[values.censusRegisterAreaCode.length - 1] : ''
        }
        // 身份信息处理
        if (empFilePaths) {
            let employeePhotoUrl = getImgRelativePath(values.employeePhotoUrl[0]);
            let idCardFrontUrl = getImgRelativePath(values.idCardFrontUrl[0]);
            let idcardBackUrl = getImgRelativePath(values.idcardBackUrl[0]);
            formObj = {
                ...values,
                employeePhotoUrl,
                idCardFrontUrl,
                idcardBackUrl,
                censusRegisterAreaCode: values.censusRegisterAreaCode ? values.censusRegisterAreaCode[values.censusRegisterAreaCode.length - 1] : ''
            }
        }
        delete formObj.imgBackUrl
        delete formObj.imgFrontUrl
        formObj = trimObj(formObj, 'trim');
        setLoading(true)
        insertOrUpdateProjectExternalEmployee({
            ...formObj
        }).then((res) => {
            setLoading(false)
            message.success(res.message || "操作成功")
            reloadList()
            closeDetails()
        }).catch(() => {
            setLoading(false)
        })
    };
    const getOptions = async (): Promise<any> => {
        setIsLoading(true)
        const orgList = await findOrgTree({});
        const bankNameList = await getBanksList({ bankNameKeyword: '' });
        const banksAreasList = await getBanksAreasList({ areaNameKeyword: '' });
        const banksLocationsList = await getBanksLocationsList({ branchNameKeyword: '' });
        const WorkerTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.worker.enums.WorkerTypeEnum")
        const workTypeList: any = await getWorkTypeList(true);
        const provinceList = await getRegionList();
        const ownerUserList = await getEmployee(1, 10, {});
        const vendorInfoList: any = await getVendorInfoList(1, 10, {});
        setIsLoading(false)
        setVendorInfoList(vendorInfoList?.records || [])
        setBankNameList(bankNameList)
        setBanksAreasList(banksAreasList)
        setBanksLocationsList(banksLocationsList)
        setOrgList(orgList)
        setOwnerUserList(ownerUserList)
        setProvinceList(provinceList)
        return Promise.resolve({
            sexList: [{ value: true, label: '男' }, { value: false, label: '女' }],
            WorkerTypeEnum,
            orgList,
            workTypeList,
        });
    }
    /**
    * 对通用选项进行处理
    * @param value 
    */
    const filterWorkTypeData = (value: any) => {
        const state = formRef.current?.getState?.()
        const newWorkTypeList = map(cloneDeep(state?.workTypeList), (item: any) => {
            if (value && Array.isArray(value) && value.length > 0) {
                if (value?.[0].label === "项目经理") {
                    item.disabled = item.name === '项目经理' ? false : true
                } else {
                    item.disabled = item.name === '项目经理' ? true : false
                }
            } else {
                item.disabled = false
            }
            return item
        })
        formRef.current?.updateState({
            workTypeList: cloneDeep(newWorkTypeList)
        })
    }
    // 使用 useCallback 来记忆这个函数
    const onSearchVendorList = useCallback(async (value: string) => {
        const vendorInfoList: any = await getVendorInfoList(1, 10, { vendorCodeOrName: value });
        setVendorInfoList(vendorInfoList?.records || []);
    }, []);
    const onSearchbankName = (value: string) => {
        getBanksList({ bankNameKeyword: value }).then((response: any) => {
            setBankNameList(response)
        });
    }
    const onSearchBanksAreas = (value: string) => {
        getBanksAreasList({ areaNameKeyword: value }).then((response: any) => {
            setBanksAreasList(response)
        });
    }
    const onSearchBanksLocations = (value: string, areaCode?: any) => {
        getBanksLocationsList({ areaCode, bankCode, branchNameKeyword: value }).then((response: any) => {
            setBanksLocationsList(response)
        });
    }
    const onSelectbankName = (_value, data) => {
        setBankCode(data?.key)
        setBanksLocationsList([])
    }
    const onSelectBanksAreas = (_value, data) => {
        setAreaCode(data?.key)
        onSearchBanksLocations('', data?.key)
    }
    const onSelectBankBranchName = (_value, data) => {
        const values = formRef.current?.onFormRef()?.getFieldsValue();
        values.bankBranchNumber = data?.dataId;
        values.bankBranchCode = data?.key;
        formRef.current?.onFormRef()?.setFieldsValue({ ...values });
    }
    const onAddEmpFilePaths = () => {
        empFilePaths ? setEmpFilePaths(false) : setEmpFilePaths(true)
    }
    const changeCascader = (_value, data) => {
        formRef.current?.onFormRef()?.setFieldValue('censusRegisterAreaName', data[data.length - 1].object.fullName);
    }
    const onSearchOwnerUser = async (value: string) => {
        const ownerUserList = await getEmployee(1, 10, {userNameKeyword: value});
        setOwnerUserList(ownerUserList)
    }
    const beforeUpload = (file: any) => {
        if ((file.type || '').startsWith('image')) {
            if (!file.name.endsWith('.jpg') && !file.name.endsWith('.bmp') && !file.name.endsWith('.png') && !file.name.endsWith('.jpeg')) {
                message.error('图片必须是jpg/jpeg/png/bmp格式')
                return Upload.LIST_IGNORE
            }
            return true
        }
        message.error('只能上传图片')
        return Upload.LIST_IGNORE
    }
    // 添加一个函数来检查节点是否为叶子节点
    const treeData = useMemo(
        () => treeFormat(orgList || [], {
            format: (item) => ({ ...item, disabled: (item.children || []).length || item.object.orgType === "COMPANY" })
        }),
        [orgList]
    )
    const configs: Array<IConfig> = [
        {
            title: '基本信息',
            titleMode: 'drawer',
            formItem: [
                {
                    name: 'name',
                    label: '姓名',
                    required: true,
                    spanCol: 12,
                    maxLength: 20,
                },
                {
                    name: 'phone',
                    label: '电话',
                    required: true,
                    spanCol: 12,
                    type: 'inputNumber',
                    maxLength: 20,
                    rules: [{ required: true, message: '请输入电话号码', pattern: phoneRegExp }],
                },
                {
                    name: 'idCard',
                    label: '身份证号',
                    required: true,
                    rules: [{ required: true, message: '请输入身份证号', pattern: idRegExp }],
                    spanCol: 12,
                    maxLength: 20,
                },
                {
                    name: 'sex',
                    label: '性别',
                    spanCol: 12,
                    required: true,
                    data: 'sexList',
                    type: 'select',
                },
                {
                    name: 'type',
                    label: '人员类型',
                    required: true,
                    spanCol: 12,
                    data: 'WorkerTypeEnum',
                    type: 'select',
                    comConfig: {
                        fieldNames: {
                            label: 'description',
                            value: 'key'
                        }
                    }
                },
                {
                    name: 'workTypeIds',
                    label: '技能标签',
                    required: true,
                    spanCol: 12,
                    data: 'workTypeList',
                    type: 'select',
                    comConfig: {
                        mode: 'multiple',
                        labelInValue: true,
                        fieldNames: { label: 'name', value: 'id' },
                        onChange: (value) => {
                            filterWorkTypeData(value)
                        }
                    },
                },
                {
                    spanCol: 24, label: '业务组织', name: 'orgIds',
                    required: true,
                    rules: [{ required: true, message: '业务组织不能为空' }],
                    children: <SLocalTreeSelected treeCheckable treeDefaultExpandAll
                        loading={isLoading}
                        fieldNames={{ label: 'label', value: 'id' }}
                        treeData={treeData} />,

                },
                {
                    name: 'ownerUserId', label: '推荐人', type: 'select', spanCol: 12,
                    children: (
                        <Select
                            fieldNames={{ label: 'userName', value: 'ucenterUserId' }}
                            placeholder={'请选择推荐人'}
                            loading={isLoading}
                            filterOption={false} // 禁用本地过滤
                            notFoundContent={null} // 搜索时不显示"无匹配结果"
                            onSearch={onSearchOwnerUser}
                            options={ownerUserList} showSearch />)
                },
                {
                    name: 'emergencyPhone',
                    label: '紧急电话',
                    spanCol: 12,
                    maxLength: 12,
                    type: 'inputNumber',
                    rules: [{ message: '请输入紧急电话', pattern: phoneRegExp }],
                },
                {
                    name: 'industryAge',
                    label: '行业工龄',
                    spanCol: 12,
                    maxLength: 2,
                    type: 'inputNumber',
                    comConfig: {
                        min: 1,
                        max: 99,
                        precision: 0
                    }
                },
                {
                    name: 'orderAbility',
                    label: '接单能力',
                    spanCol: 12,
                    maxLength: 3,
                    type: 'inputNumber',
                    comConfig: {
                        min: 1,
                        max: 999,
                        precision: 0
                    }
                },
                {
                    name: 'censusRegisterAreaCode',
                    label: '户籍所在地',
                    required: false,
                    spanCol: 12,
                    type: 'select',
                    children: <Cascader options={provinceList} placeholder="请选择户籍所在地" fieldNames={{ label: 'label', value: 'id', children: 'children' }} onChange={changeCascader} />
                },
                {
                    name: 'vendorInfoIds',
                    label: '承包商',
                    spanCol: 12,
                    children: <Select placeholder={'请选择承包商'} mode='multiple'
                        fieldNames={{ label: 'name', value: 'id' }}
                        onSearch={onSearchVendorList}
                        options={vendorInfoList} showSearch
                        filterOption={false} // 禁用本地过滤
                        notFoundContent={null} // 搜索时不显示"无匹配结果"
                    />,
                },
                {
                    name: 'addressAddress',
                    label: '居住地',
                    spanCol: 24,
                    comConfig: {
                        maxLength: 30,
                    },
                },
                {
                    name: 'workExperience',
                    label: '从业经历描述',
                    spanCol: 24,
                    maxLength: 100,
                },

            ],
        },
        {
            title: '身份信息',
            titleMode: 'drawer',
            customBtn: [
                <Button type="primary"
                    onClick={onAddEmpFilePaths}>{empFilePaths ? '删除身份信息' : '添加身份信息'}</Button>,
            ],
            formItem: empFilePaths ? [
                {
                    name: 'employeePhotoUrl',
                    label: '个人照片',
                    spanCol: 8,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={selfPositive} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} />,
                },
                {
                    name: 'idCardFrontUrl',
                    label: '身份证人面像',
                    spanCol: 8,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={cardFront} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} />,
                },
                {
                    name: 'idcardBackUrl',
                    label: '身份证国徽面',
                    spanCol: 8,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={nationalEmblem} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} s />,
                }
            ] : [],
        },
        {
            title: '银行卡信息',
            titleMode: 'drawer',
            formItem: [
                {
                    name: 'imgFrontUrl',
                    label: '银行卡正面',
                    spanCol: 12,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={bankCardFront} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} />,
                },
                {
                    name: 'imgBackUrl',
                    label: '银行卡背面',
                    spanCol: 12,
                    required: true,
                    htmlFor: 'imgUrl',
                    children: <ImageUpload exampleImgSrc={backBankCard} limit={1} accept={'image/png,image/bmp,image/jpeg,image/jpg'} beforeUpload={beforeUpload} />,
                },
                {
                    name: 'idCard',
                    label: '身份证号',
                    required: true,
                    spanCol: 12,
                    maxLength: 20,
                    comConfig: {
                        disabled: true,
                    },

                },
                {
                    name: 'bankName', label: '银行名称', type: 'select', data: 'bankNameList', required: true, spanCol: 12,
                    children: <Select showSearch={true} onSearch={onSearchbankName}
                        onChange={onSelectbankName} placeholder={'请选择银行名称'}>
                        {bankNameList.map((item: any) => (
                            <Option key={item.bankCode} value={item.bankName}>
                                {item.bankName}
                            </Option>
                        ))}
                    </Select>
                },
                {
                    name: 'cityName', label: '所在城市', type: 'select', data: 'banksAreasList', required: true, spanCol: 12,
                    children: <Select showSearch={true} onSearch={onSearchBanksAreas}
                        onChange={onSelectBanksAreas} placeholder={'请选择所在城市'}>
                        {banksAreasList.map((item: any) => (
                            <Option key={item.areaCode} value={item.areaName}>
                                {item.areaName}
                            </Option>
                        ))}
                    </Select>
                },
                {
                    name: 'bankBranchName', label: '支行名称', type: 'select', data: 'banksLocationsList', required: true, spanCol: 12,
                    children: <Select showSearch={true} onSearch={onSearchBanksLocations}
                        filterOption={false} // 禁用本地过滤
                        notFoundContent={null} // 搜索时不显示"无匹配结果"
                        onChange={onSelectBankBranchName}
                        placeholder={'请选择支行名称'}>
                        {banksLocationsList.map((item: any) => (
                            <Option key={item.branchCode} value={item.branchName} dataId={item.id}>
                                {item.branchName}
                            </Option>
                        ))}
                    </Select>
                },
                {
                    name: 'bankBranchNumber', label: '银行网点联行号', spanCol: 12, comConfig: {
                        disabled: true,
                    }
                },
                {
                    name: 'name',
                    label: '开户名',
                    spanCol: 12,
                    maxLength: 50,
                    required: true,
                    comConfig: {
                        disabled: true,
                    }
                },
                {
                    name: 'accountCode',
                    label: '银行卡号',
                    spanCol: 12,
                    maxLength: 50,
                    required: true,
                },
                { name: 'bankBranchCode', hidden: true },
                { name: 'bankBranchNumber', hidden: true },
                { name: 'censusRegisterAreaName', hidden: true }
            ],
        }
    ]
    return (
        <>
            <SDrawer
                width={800}
                title={title}
                open={visibleDrawer}
                onClose={closeDetails}
                onSubmit={onSubmit}
                loading={loading}
                destroyOnClose
            >
                <SGeneralForms
                    ref={formRef}
                    layout="vertical"
                    httpOptionsFn={getOptions}
                    configs={configs}
                />
            </SDrawer>
        </>
    );
};
export default Add
